export default "__VITE_ASSET__xQj9Sl8r__"